










































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  Expense,
  ExpenseItem,
  saveExpense,
  newExpenseItem,
  SaveExpenseCommand
} from "../../../api/cost/expenses-api";
import Draggable from "vuedraggable";
import ExpenseSummary from "../components/ExpenseSummary.vue";
import ExpenseItemListItem from "./ExpenseItemListItem.vue";
import { cloneDeep, debounce } from "lodash";
import ExpenseItemListHeader from "./ExpenseItemListHeader.vue";
import SelectOption from "@/common/ui/presenters/select-option";
import { getVendorOptions } from "@/api/company-api";

@Component({
  components: {
    Draggable,
    ExpenseSummary,
    ExpenseItemListHeader,
    ExpenseItemListItem
  }
})
export default class ExpenseForm extends Vue {
  @Prop({ type: Object }) defaultValues?: Expense;

  dragging = false;

  values: SaveExpenseCommand = {
    id: "",
    date: "",
    vendorId: "",
    title: "",
    items: []
  };

  vendorOptions: SelectOption[] = [];

  @Watch("defaultValues", { immediate: true })
  onDefaultValuesChanged(values: Expense) {
    if (!values) {
      return;
    }
    this.values = cloneDeep(values);
  }

  public created() {
    this.$store.dispatch("initExpenseCategories");
    this.initVendorOptions();
  }

  public async submit() {
    await saveExpense(this.values);
    this.$emit("submit");
  }

  /**
   * 変更
   *
   * ここで再計算すれば、更新に合わせて色々処理できる
   */
  handleChange() {
    // TODO: なぜか更新したら2回走るのやめさせたい。
    updateItems(this.values.items);

    this.$emit("change", this.values);
  }

  handleItemChange = debounce(() => {
    this.handleChange();
  }, 50);

  async initVendorOptions() {
    this.vendorOptions = await getVendorOptions();
  }

  /**
   * 最後に新しい項目を1行追加する
   */
  addItem() {
    this.values.items.push(newExpenseItem());
    this.handleChange();
  }

  /**
   * 最後に新しい項目を5行追加する
   */
  addFiveItems() {
    for (let i = 0; i < 5; i++) {
      this.values.items.push(newExpenseItem());
    }
    this.handleChange();
  }

  /**
   * 指定した項目の後に新しい項目を追加する
   */
  addItemAfter(item: ExpenseItem) {
    const append = (items: ExpenseItem[], itemId: string): boolean => {
      const i = items.findIndex(item => item.id === itemId);
      if (i < 0) {
        return items.some(item => append(item.items, itemId));
      } else {
        items.splice(i + 1, 0, newExpenseItem());
        return true;
      }
    };
    if (append(this.values.items, item.id)) {
      this.handleChange();
    }
  }

  /**
   * 指定した項目を削除する
   */
  removeItem(item: ExpenseItem) {
    const remove = (items: ExpenseItem[], itemId: string): boolean => {
      const i = items.findIndex(item => item.id === itemId);
      if (i < 0) {
        return items.some(item => remove(item.items, itemId));
      } else {
        items.splice(i, 1);
        return true;
      }
    };
    if (remove(this.values.items, item.id)) {
      this.handleChange();
    }
  }

  removeAllItems() {
    if (!confirm("すべての項目を削除してもよろしいですか？")) {
      return;
    }
    this.values.items = [];
    this.handleChange();
  }

  canMoveItem(e: {
    to: HTMLElement;
    draggedContext: { element: ExpenseItem };
  }) {
    const indent = Number(e.to.dataset["indent"]);
    // 入れ子を2段にするため、子のいる親は子になれない
    return indent > -1 && e.draggedContext.element.items.length === 0;
  }
}

/**
 * 項目を更新する
 */
function updateItems(items: ExpenseItem[]): void {
  items.forEach(item => {
    updateItems(item.items);
    if (item.items.length > 0) {
      item.expenseCategoryId = "";
    }
    item.unitPrice =
      item.items.length > 0
        ? item.items.reduce((s, i) => s + i.total, 0)
        : item.unitPrice;
    item.total = item.unitPrice * item.amount;
  });
}
